(function ($) {
  // register namespace
  $.extend(true, window, {
    "Slick": {
      "StubSelectionModel": StubSelectionModel
    }
  });


  function StubSelectionModel(options) {
    var _grid;
    var _canvas;
    var _ranges = [];
    var _self = this;

    this.init = function (grid) {
      self._grid = grid;     
    };

    this.destroy = function () {      
    };



    $.extend(this, {
      "init": this.init,
      "destroy": this.destroy,
      "getSelectedRanges": function () { return []; },
      "setSelectedRanges": function () { },
      "onSelectedRangesChanged": new Slick.Event()
    });
  }
})(jQuery);
